import React from 'react';
import SubContext from './SubContext';
import SubSelector from './SubSelector';
import { Typography } from '@material-ui/core';

const Sub = () => {
  const ctx = React.useContext(SubContext);

  return (
    <div>{ctx.subs.length > 1 ? <SubSelector /> : <SingleSubDisplay />}</div>
  );
};

const SingleSubDisplay = () => {
  const ctx = React.useContext(SubContext);

  return (
    <div>
      {ctx.subs.length === 0 ? (
        <Typography>Loading Subscribers...</Typography>
      ) : (
        <Typography>Subscriber: {ctx.selectedSub}</Typography>
      )}
    </div>
  );
};

export default Sub;
